







import {Vue, Component, Prop} from "vue-property-decorator";
import FormGroup from "@/components/ui/forms/FormGroup.vue";
import {HashMap} from "./../services/base.service";
import ServiceList from "@/components/ServiceList.vue";
import CardCollapsible from "@/components/ui/CardCollapsible.vue";

@Component({
    components: {
        ServiceList,
        CardCollapsible,
    }
})
export default class ServiceManager extends Vue {
    private async submit() {
        
    }
}

